import { Component } from '@angular/core';
import {BehaviorSubject, combineLatest} from "rxjs";
import NoteModel from "../../../../model/note.model";
import ContextBarService from "../context-bar.service";
import NoteService from "../../../../api/note/note.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {debounceTime} from "rxjs/operators";
import TaskService from "../../../../api/task/task.service";
import CooperationTaskModel from "../../../../model/cooperationTask.model";

@Component({
  selector: 'context-bar-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.scss']
})
export class TasksComponent {
  private tasksSubject = new BehaviorSubject<CooperationTaskModel[]>([]);
  public tasks$ = this.tasksSubject.asObservable();

  private pageSubject = new BehaviorSubject<number>(1);
  public page$ = this.pageSubject.asObservable();

  private querySubject = new BehaviorSubject<string>(null);
  public query$ = this.querySubject.asObservable();

  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  public taskCount = 0;

  public constructor(private contextBarService: ContextBarService, private taskService: TaskService, private snackBar: MatSnackBar) {
    combineLatest([ this.contextBarService.artist$, this.contextBarService.cooperation$, this.contextBarService.customer$, this.query$]).subscribe(_ => {
      this.pageSubject.next(1);
    });

    combineLatest([
      this.contextBarService.artist$, this.contextBarService.cooperation$, this.contextBarService.customer$, this.page$, this.query$
    ]).pipe(debounceTime(500)).subscribe(([artist, cooperation, customer, page, query]) => {
      let additional = {};

      if(artist) {
        additional['artist'] = artist.id;
      }
      if(cooperation) {
        additional['cooperation'] = cooperation.id;
      }
      if(customer) {
        additional['customer'] = customer.id;
      }

      this.loadingSubject.next(true);
      this.taskService.list(query, page, 25, 'created', 'DESC', additional).subscribe(result => {
        if(page == 1) {
          this.tasksSubject.next(result.results);
        } else {
          let items = this.tasksSubject.getValue();
          items = items.concat(result.results);
          this.tasksSubject.next(items);
        }
        this.loadingSubject.next(false);
        this.taskCount = result.total;
      })
    });
  }
  queryChanged(query) {
    this.querySubject.next(query);
  }

  onScroll() {
    if(this.tasksSubject.getValue().length < this.taskCount) {
      this.pageSubject.next(this.pageSubject.getValue() + 1);
    }
  }

  addTask(task: CooperationTaskModel) {

  }
}
